var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "catalog-tabs" }, [
    _c(
      "ul",
      { staticClass: "catalog-tabs__list" },
      _vm._l(_vm.getSubCategories(null), function (model) {
        return _c("li", { staticClass: "catalog-tabs__item" }, [
          _c(
            "label",
            {
              staticClass: "label-radio",
              class: { "is-active": _vm.isActive(model.id) },
              attrs: { for: model.id },
            },
            [
              _vm._v(
                "\n                " + _vm._s(model.name) + "\n                "
              ),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.active,
                    expression: "active",
                  },
                ],
                attrs: { type: "radio", name: "options", id: model.id },
                domProps: {
                  value: model.id,
                  checked: _vm._q(_vm.active, model.id),
                },
                on: {
                  change: function ($event) {
                    _vm.active = model.id
                  },
                },
              }),
            ]
          ),
          _vm._v(" "),
          _vm.getSubCategories(model.id).length > 0
            ? _c(
                "ul",
                { staticClass: "catalog-tabs__middle" },
                _vm._l(_vm.getSubCategories(model.id), function (model_l1) {
                  return _c("li", { staticClass: "catalog-tabs__item" }, [
                    _c(
                      "label",
                      {
                        staticClass: "label-radio",
                        class: { "is-active": _vm.isActive(model_l1.id) },
                        attrs: { for: model_l1.id },
                      },
                      [
                        _vm._v(
                          "\n                        " +
                            _vm._s(model_l1.name) +
                            "\n                        "
                        ),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.active,
                              expression: "active",
                            },
                          ],
                          staticClass: "menu-top_link radiobutt",
                          attrs: {
                            type: "radio",
                            name: "options",
                            id: model_l1.id,
                          },
                          domProps: {
                            value: model_l1.id,
                            checked: _vm._q(_vm.active, model_l1.id),
                          },
                          on: {
                            change: function ($event) {
                              _vm.active = model_l1.id
                            },
                          },
                        }),
                      ]
                    ),
                    _vm._v(" "),
                    _vm.getSubCategories(model_l1.id).length > 0
                      ? _c(
                          "ul",
                          { staticClass: "catalog-tabs__bottom" },
                          _vm._l(
                            _vm.getSubCategories(model_l1.id),
                            function (model_l2) {
                              return _c(
                                "li",
                                { staticClass: "catalog-tabs__item" },
                                [
                                  _c(
                                    "label",
                                    {
                                      staticClass: "label-radio",
                                      class: {
                                        "is-active": _vm.isActive(model_l2.id),
                                      },
                                      attrs: { for: model_l2.id },
                                    },
                                    [
                                      _vm._v(
                                        "\n                                " +
                                          _vm._s(model_l2.name) +
                                          "\n                                "
                                      ),
                                      _c("input", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value: _vm.active,
                                            expression: "active",
                                          },
                                        ],
                                        staticClass: "menu-top_link radiobutt",
                                        attrs: {
                                          type: "radio",
                                          name: "options",
                                          id: model_l2.id,
                                        },
                                        domProps: {
                                          value: model_l2.id,
                                          checked: _vm._q(
                                            _vm.active,
                                            model_l2.id
                                          ),
                                        },
                                        on: {
                                          change: function ($event) {
                                            _vm.active = model_l2.id
                                          },
                                        },
                                      }),
                                    ]
                                  ),
                                ]
                              )
                            }
                          ),
                          0
                        )
                      : _vm._e(),
                  ])
                }),
                0
              )
            : _vm._e(),
        ])
      }),
      0
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }